import { createFileRoute } from "@tanstack/react-router";
import ExplorerPage from "@/pages/Explorer";
import { explorerSearchSchema } from "@/features/explorer/lib/url-state";

export const Route = createFileRoute("/")({
  validateSearch: explorerSearchSchema,
  component: ExplorerPage,
});
